import React, { FC } from "react"
import styled from "styled-components"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faSpinner } from "@fortawesome/free-solid-svg-icons"

const SpinnerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
`

const SpinnerIcon = styled(FontAwesomeIcon)`
  font-size: 2rem;
`

const LoadingSpinner: FC = () => {
  return (
    <SpinnerContainer>
      <SpinnerIcon icon={faSpinner} spin />
    </SpinnerContainer>
  )
}

export default LoadingSpinner
